import { Metric, MetricForTable } from "@models/Metric";
import { useCallback } from "react";
import { TableColumn } from "@components/Table/TableColumns";
import { useGetMetric } from "@core/CommonDataContext";
import { COMMON_NUM_COL_WIDTH } from "@core/constants";

export function useGetMetricRawTableCell (
    data: Array<{
        metrics: MetricForTable[],
    }>,
    metricsIds: Metric[],
) {
    const getMetric = useGetMetric();

    return useCallback(
        (metricIndex: number): TableColumn => {
            const metric = getMetric(metricsIds[metricIndex]);

            return {
                key: metric?.name ?? `metric-${metricIndex}-raw`,
                head: metric?.name ?? `Metric ${metricIndex}`,
                headText: metric?.name ?? `Metric ${metricIndex}`,
                Value: ({ index }) => <>
                    {data[index].metrics[metricIndex].tableValue}
                </>,
                valueText: (index) => data[index].metrics[metricIndex].copyTableValue,
                style: {
                    cell: {
                        flex: `0 0 ${COMMON_NUM_COL_WIDTH}`,
                        justifyContent: "center",
                        textAlign: "center",
                    }
                }
            };
        },
        [data, getMetric, metricsIds]
    );
}